<template>
  <div>
    <p>An active job with a reinspection task exists for the selected project. Please select below to view or edit the existing task. Close this window if you wish to continue creating a new job.</p>
    <div class="row">
      <div class="col-md-12">
        <table style="width:100%" class="table-user-data">
          <colgroup>
            <col style="width:50%">
            <col style="width:50%">
          </colgroup>
          <tr>
            <td>Job Name</td>
            <td>{{ data.jobName }}</td>
          </tr>
          <tr>
            <td>Task Name</td>
            <td>{{ data.task.name }}</td>
          </tr>
          <tr>
            <td>Task Assignee</td>
            <td>{{ getUserDisplayName(data.task.assigneeId) }}</td>
          </tr>
          <tr>
            <td>Task Status</td>
            <td>{{ data.task.status }}</td>
          </tr>
          <tr>
            <td>Task Created Date</td>
            <td>{{ data.task.createdAt | formatDate }}</td>
          </tr>
        </table>
      </div>
      <div class="col-md-12">
        <button type="button" @click="editTask" class="btn btn-fill btn-info btn-wd pull-right">View/Edit Task</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['data'],
  methods: {
    getUserDisplayName(userId) {
      if (!userId) {
        return 'Unassigned'
      }
      return this.$store.getters['users/displayName'](userId)
    },
    editTask() {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', this.data.task, '80%')
    }
  }
}
</script>

<style scoped>

</style>
